export const ORDERS = "ORDERS";
export const INIT_ORDERS = "INIT_ORDERS";

export const ADD_INGREDIENT = "ADD_INGREDIENT";
export const INIT_INGREDIENT = "INIT_INGREDIENT";
export const REMOVE_INGREDIENT = "REMOVE_INGREDIENT";
export const FIRST_INIT_INGREDIENT = "FIRST_INIT_INGREDIENT";

export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_USER = "AUTH_USER";
export const AUTH_START = "AUTH_START";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_CHECK_TIMEOUT = "AUTH_CHECK_TIMEOUT";
export const AUTH_INITIATE_LOGOUT = "AUTH_INITIATE_LOGOUT";
export const AUTH_USER_CHECK_STATE = "AUTH_USER_CHECK_STATE";
